import React from "react";
import { Link } from "react-router-dom";

function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl font-bold text-foreground mb-2">
            Privacy Policy
          </h1>
          <p className="text-muted-foreground mb-10">
            Last updated: October 23, 2026
          </p>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-foreground mb-3">
              1. Information We Collect
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              We collect information you provide directly, such as your email address
              when you create an account (there are no passwords: you sign in with
              a one-time code emailed to you, or with Google). We also collect the
              flashcard content you create and usage data to improve the
              service, such as study session activity and feature interactions.
            </p>
            <p className="text-muted-foreground leading-relaxed mt-3">
              Our own first-party analytics, with no third-party trackers, records which
              pages are visited, time spent, which links and buttons are clicked, and
              key actions such as signing in, creating and studying flashcards or
              subscribing, together with the browser, device type, approximate country
              and whether you are signed in (never your account or email). It never
              records what you type or the text of your flashcards, and IP addresses are
              not stored. A random identifier kept in your browser's local storage
              recognizes returning visits; visitors from the EU, the UK and Switzerland
              are counted without it. Browsers that send Do Not Track or Global Privacy
              Control are not tracked.
            </p>
            <p className="text-muted-foreground leading-relaxed mt-3">
              The mobile app uses the same analytics: which screens are opened, which
              buttons are tapped, whether flashcards are created and studied, and app
              errors, together with the app version, device type and approximate country,
              and whether you are signed in (never your account or email). A random
              identifier stored on the device recognizes the same install; devices set to
              the EU, the UK or Switzerland are counted without it.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-foreground mb-3">
              2. How We Use Your Information
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              We use your information to provide and operate the Laftel Lingo
              service, send account-related emails (such as sign-in codes), process payments securely through our payment
              provider, and improve the product based on usage patterns.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-foreground mb-3">
              3. Data Storage and Security
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              Your data is stored on secure servers. Sign-in codes are stored only
              as hashes and expire after 15 minutes. We take reasonable technical and
              organizational measures to protect your information, though no
              internet transmission is completely secure.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-foreground mb-3">
              4. Third-Party Services
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              We use third-party services to operate Laftel Lingo, including
              OpenAI for AI-powered flashcard generation, Stripe for payment
              processing, and Mailgun for email delivery. These providers have
              their own privacy policies governing how they handle your data.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-foreground mb-3">
              5. Data Retention
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              We retain your account and flashcard data for as long as your
              account is active. You may delete your account at any time by
              contacting us, after which we will remove your personal data
              within a reasonable timeframe.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-foreground mb-3">
              6. Your Rights
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              You may access, update, or request deletion of your personal data
              by contacting us. You may also opt out of non-essential
              communications at any time.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-foreground mb-3">
              7. Changes to This Policy
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              We may update this Privacy Policy from time to time. When we do,
              we will revise the date at the top of this page. Continued use of
              the service after changes constitutes acceptance of the updated
              policy.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-foreground mb-3">
              8. Contact
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              If you have questions about this Privacy Policy, please contact us
              at{" "}
              <a
                href="mailto:support@laftel.io"
                className="text-primary hover:underline"
              >
                support@laftel.io
              </a>
              .
            </p>
          </section>

          <div className="mt-10 pt-6 border-t border-border">
            <Link to="/" className="text-primary hover:underline">
              ← Back to Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicyPage;
